import React, { useState } from "react";
import { useParams } from "react-router-dom";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const param = useParams()

  console.log(param.token)

  return (
    <div className="bg-brand_nero flex flex-col justify-center items-center h-[800px] py-24 my-auto text-white  w-full">
      <div className="bg-brand_jaguar h-[400px] px-24 flex flex-col justify-center items-center w-[600px]">
        <form action="" className="flex-col flex px-4 my-6 w-[400px] ">
          <h1 className="text-xl text-center my-3">Enter New Password</h1>

          <input
            className="my-3 py-1 px-6 text-black border-none outline-brand_yellow"
            type="text"
            value={newPassword}
            placeholder="New Password"
            onChange={(e) => {
              setNewPassword(e.target.value);
            }}
          />

          <button className="transition hover:-translate-y-1 ease-linear my-3 bg-brand_yellow px-6 py-1 text-black font-outfit font-semibold">
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
